import RevertDeprecateAssetModal from './RevertDeprecateAssetModal.container';

export default RevertDeprecateAssetModal;
